import { Card } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

export interface DashboardSectionErrorProps {
  /** Error message to display */
  message: string;
}

const DashboardSectionError: FC<DashboardSectionErrorProps> = ({ message }) => {
  return (
    <Card>
      <Card.Body>
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <UntitledIcon
            name="alert-triangle.3"
            className="mb-2 size-8 text-red-400"
          />
          <p className="supporting-body text-gray-500">{message}</p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DashboardSectionError;
